import i18n from '../../locales/index'
import restful from '../vuex'
import axios from 'axios'
import { Spin } from 'view-design'
// const SHOPID = +localStorage.getItem('SHOPID')
const state = {
  ...restful.states('shop'),
  masterShops: [] // 主店

}

const getters = {
  ...restful.getters('shop'),
  otherShops: (state) => state.shops,
  masterShops: (state) => state.masterShops,
}

const actions = {
  ...restful.actions('shops'),
  async master_index ({ commit }, params) {
    Spin.show()
    const res = await axios.get('shops/master_index', params)
    commit('masterShops', res.data)
    Spin.hide()
  },
  // async activate ({ commit }, params) {
  //   Spin.show()
  //   const response = await axios.post(`shops/${params.id}/activate`, params)
  //   commit('updateRecordInRecords', response.data)
  //   Spin.hide()
  //   Message.success('激活成功!')
  // },
  // async shop_reduce ({ commit }, id) {
  //   Spin.show()
  //   const response = await axios.post(`shops/${id}/shop_reduce`)
  //   commit('updateRecordInRecords', response.data)
  //   Spin.hide()
  //   Message.success('降级标准版成功!')
  // },
  async shop_charge ({ commit }, params) {
    Spin.show()
    const response = await axios.post('shop_charges/alipay_url', params)
    Spin.hide()
    return response.data
  },
  async shop_buyable_list ({ commit }, id) {
    Spin.show()
    const response = await axios.get(`distributor_company_buyable_shops?q[shop_id_eq]=${id}`)
    Spin.hide()
    return response.data
  }
}

const mutations = {
  ...restful.mutations('shop'),
  masterShops (state, masterShops) {
    state.masterShops = masterShops
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
